import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';

export function getCurrentScript() {
    const currentScript =
        document.currentScript ||
        (() => {
            const scripts = document.getElementsByTagName('script');
            const regex = /\/applicationManager\/apps\/(.*)\/main\.js$/;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < scripts.length; i++) {
                const script = scripts[i];
                const match = regex.exec(script.src);
                if (match && match.length > 1) {
                    return script;
                }
            }
            return undefined;
        })();
    return currentScript;
}
export const CURRENT_SCRIPT = getCurrentScript() as HTMLScriptElement;

const root =
    document.getElementById('fundCenter') ||
    document.getElementById('kurtosysDocLibrary');

const renderApp = intlSupported => {
    let src = '';
    if (CURRENT_SCRIPT) {
        src = (CURRENT_SCRIPT as HTMLScriptElement).src;
    }
    ReactDOM.render(
        // Set intlSupported prop
        // Spread data-attributes from root element as props
        // Pass script tag src as prop
        <App
            intlSupported={intlSupported}
            scriptSrc={src}
            {...root.dataset}
            root={root}
        />,
        root
    );
};

// Dynamic import Intl polyfill
const loadIntlPolyfill = async () => {
    await import(/* webpackChunkName: "intl" */ 'intl');
};

export function getApplicationCode() {
    if (process.env.NODE_ENV === 'development') {
        return 'af3b9334-5e9f-488d-90ef-633df6ebe0d0';
    }
    const currentScript = CURRENT_SCRIPT;
    if (currentScript) {
        // tslint:disable-next-line: no-shadowed-variable
        const { src } = currentScript as any;
        const regex = /\/apps\/(.*)\/main\.js$/;
        const match = regex.exec(src);
        if (match && match.length > 1) {
            const [, applicationCode] = match;
            return applicationCode;
        }
    }
    return;
}

// Load Intl polyfill where required then render app
if (!(window as any).Intl) {
    console.info('Intl API unsupported');
    loadIntlPolyfill();
    renderApp(false);
} else {
    console.info('Intl API supported');
    renderApp(true);
}



// WEBPACK FOOTER //
// ./src/index.tsx